// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_lite-gray.less
// module id = ./resources/assets/less/app_lite-gray.less
// module chunks = 0